"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProject = parseProject;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const altiumValidation_1 = require("./altiumValidation");
const altiumFileTypes_1 = require("./altiumFileTypes");
const altiumProjectFileUtil_1 = require("./parsers/project/altiumProjectFileUtil");
const altiumProjectFileTypes_1 = require("./parsers/project/altiumProjectFileTypes");
const AltiumHierarchicalSchematicProcessor_1 = require("./parsers/schdoc/transformation/AltiumHierarchicalSchematicProcessor");
const Font_1 = require("../Font");
const AltiumSchematic_1 = require("./parsers/schdoc/helpers/AltiumSchematic");
const ModelText_1 = require("../../ModelText");
function parseProject(def, opts = {}) {
    if (def.type !== 'altium') {
        throw new Error(`Attempted to parse non-altium project def: ${def.type}`);
    }
    const buildDef = def;
    const projectConfiguration = loadProjectConfigFromDef(buildDef) ?? (0, altiumProjectFileTypes_1.emptyAltiumProjectFile)();
    const projectStructure = loadProjectStructureFromDef(buildDef);
    const projectConfigUtil = new altiumProjectFileUtil_1.AltiumProjectFileUtil(projectConfiguration, projectStructure);
    const processor = new AltiumHierarchicalSchematicProcessor_1.AltiumHierarchicalSchematicProcessor(def, projectConfigUtil, {
        netNamingDebug: opts.netNamingDebug,
    });
    processor.buildInstanceMap();
    processor.resolvePhysicalNetNames();
    const projectModel = processor.getFinalModel();
    projectModel.designHierarchy = processor.buildDesignHierarchy();
    if (def.name) {
        projectModel.name = def.name;
    }
    (0, Font_1.packModelFonts)(projectModel);
    projectModel.processingResults.innerResults.push(...processor.processingResults);
    const seenSchematics = new Set();
    for (const schematicDef of Object.values(def.schematics)) {
        if (schematicDef.validationResult?.isValid) {
            const schematic = schematicDef.validationResult.data.metadata[altiumValidation_1.AltiumProjectMetadataKey.SchDoc];
            if (schematic instanceof AltiumSchematic_1.AltiumSchematic && !seenSchematics.has(schematic)) {
                seenSchematics.add(schematic);
                projectModel.processingResults.innerResults.push(...schematic.processingResults);
            }
        }
    }
    (0, sigma_engine_shared_1.computeAggragateMessageResultSeverity)(projectModel.processingResults);
    projectModel.modelVersion = ModelText_1.MODEL_TEXT_MIN_VERSION;
    const extractedImages = processor.getExtractedImages();
    const netNamingDebug = processor.getNetNamingDebug();
    return {
        projectModel: JSON.parse(JSON.stringify(projectModel)),
        extractedImages,
        ...(netNamingDebug === undefined ? {} : { netNamingDebug }),
    };
}
function loadProjectConfigFromDef(buildDef) {
    if (!buildDef.other) {
        return undefined;
    }
    const projectFileDescriptor = Object.values(buildDef.other).find((file) => file.validationResult?.data?.metadata?.[altiumValidation_1.AltiumProjectMetadataKey.FileType] === altiumFileTypes_1.AltiumFileType.Project);
    if (!projectFileDescriptor) {
        return undefined;
    }
    return projectFileDescriptor.validationResult?.data?.metadata?.[altiumValidation_1.AltiumProjectMetadataKey.Project];
}
function loadProjectStructureFromDef(buildDef) {
    if (!buildDef.other) {
        return undefined;
    }
    const projectStructureDescriptor = Object.values(buildDef.other).find((file) => file.validationResult?.data?.metadata?.[altiumValidation_1.AltiumProjectMetadataKey.FileType] === altiumFileTypes_1.AltiumFileType.ProjectStructure);
    if (!projectStructureDescriptor) {
        return undefined;
    }
    return projectStructureDescriptor.validationResult?.data?.metadata?.[altiumValidation_1.AltiumProjectMetadataKey.ProjectStructure];
}
//# sourceMappingURL=parseAltiumProject.js.map